
import React from 'react';
import SolutionHero from './SolutionHero';

interface BespokeHeroProps {
  title: string;
  subtitle: string;
}

const BespokeHero: React.FC<BespokeHeroProps> = ({ title, subtitle }) => {
  return (
    <SolutionHero 
      title={title}
      subtitle={subtitle}
      backgroundImage="/images/aerial-forest.png"
    />
  );
};

export default BespokeHero;
